"use client";

import { c as _c } from "react/compiler-runtime";
import { bn } from "@opensea/utils";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
import { MINIMUM_OFFER_PRICE, OFFER_MAX_DECIMALS } from "../../../constants";
export const BestOfferButton = t0 => {
  const $ = _c(14);
  const {
    className
  } = t0;
  const t = useTranslations("wallet.CreateOfferBestOfferButton");
  const {
    control,
    setValue
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "offers"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const offers = useWatch(t1);
  let t2;
  if ($[2] !== offers) {
    t2 = offerIndex => {
      const bestOffer = offers[offerIndex]?.bestOffer;
      return bn(Math.max(bestOffer ?? 0, MINIMUM_OFFER_PRICE)).decimalPlaces(OFFER_MAX_DECIMALS).toNumber();
    };
    $[2] = offers;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getBestOffer = t2;
  let t3;
  if ($[4] !== getBestOffer || $[5] !== offers || $[6] !== setValue) {
    t3 = () => {
      offers.forEach((_, index) => {
        setValue(`offers.${index}.price`, getBestOffer(index), {
          shouldValidate: true
        });
      });
    };
    $[4] = getBestOffer;
    $[5] = offers;
    $[6] = setValue;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleApplyToAll = t3;
  let t4;
  if ($[8] !== t) {
    t4 = t("topOffer");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== className || $[11] !== handleApplyToAll || $[12] !== t4) {
    t5 = <Button className={className} onClick={handleApplyToAll} size="sm" variant="secondary">{t4}</Button>;
    $[10] = className;
    $[11] = handleApplyToAll;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};